export const formatPortfolioModelDate = (isoDate: string): string =>
{
    if (!isoDate) return '-';

    try
    {
        const date = new Date(isoDate);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }
    catch (error)
    {
        return '-';
    }
};